<template>
    <div>
        <TopBar
            :label="lbl.topbar.label.login"
            :isRegister="true" />
        <div  class="bg">
            <div class="pt-forgetpassword">
                <FormCreateNewPassword
                    :modalController="modalController"
                    @submit="onSubmitResetPassword($event)">
                </FormCreateNewPassword>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//helper
import FormHelper from '@/helper/FormHelper';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//component
import TopBar from '@/components/Layout/TopBar/TopbarSignUp.vue';
import FormCreateNewPassword from '../component/FormCreateNewPassword.vue';

export default {
    name: 'CreateNewPassword',
    mixins: [ModalMixin, LocaleMixin],
    components:{
        TopBar,
        FormCreateNewPassword
    },
    data() {
        return {
            errorInfo: []
        };
    },
    created: function(){
        this.errorInfo = FormHelper.genErrorInfo(2);
    },
    mounted() {

    },

    methods: {
        onSubmitResetPassword:function(data){
            this.modalController.confirmModal
                .setTitle(this.lbl.register.confirm_new_password.title)
                .setMsg(this.lbl.register.confirm_new_password.msg)
                .setBtnOk(this.lbl.default.confirm)
                .show();
            this.modalController.confirmModal.onClickOk(()=>{
                //TODO: waiting for reset api
                console.log(data)
                this.$emit('submit', data);
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/base/base.scss';
.forget-mobile {
        @include min-desktop {
            display: none;
        }
    }

.forget-desktop {
        @include tablet {
            display: none;
        }
        @include max-mobile {
            display: none;
        }
}

.link-text{
    color: $main-orange-color;
    text-decoration: underline;
}
.pt-forgetpassword{
    padding: {
        left: 20px;
        right: 20px;
        top: 70px;
        bottom: 150px;
    }
}
.bg{
    background-color: #f4f4f4;
    // background-image: url('../../../assets/bg/background.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    //min-height: calc(100vh - 50px);
    position: relative;
        // @include max-mobile {
        //     background-image: url('../../../assets/bg/bzbs-b2b-background-mobile.svg');
        //     background-size: cover;
        //     background-position: 100% 0;
        //     background-repeat: no-repeat;
        //     min-height: calc(100vh - 50px);
        //     position: relative;
        //     padding-bottom: 77px;
        // }
}
.logo-bottom{
    position: absolute;
    bottom: 30px;
    width: 100%;
    display: flex;
}
</style>
